import React, { useEffect, useState } from "react";
import { FxSelectBase, makeSelectPara } from "../../fxms/inputs/FxSelect";
import { FxMultiSelectBase } from "../../fxms/inputs/FxMultiSelect";

/**
 * VUP에서 즐겨 사용하는 INPUT ELEMENT 모음
 */

/**
 * 산단 SELECT 박스
 * @param onChangeValue 선택된 값 전단 function(id, value)
 * @param defaultValue 기본 선택값
 * @param {object} width
 * @param {string} optionText "산업단지전체" 문구 추가
* @param {string} name 변수명 없으면 "complexInloNo" 임
 * @returns
 */
export const FxSelectComplex = (props) => {
  const { onChangeValue, defaultValue, width, optionText, name } = props;
  const [datas, setDatas] = React.useState({});

  useEffect(() => {
    if (optionText) {
      setDatas(
        makeSelectPara(null, null,
          '{"type":"inlo", "inloClCd":"COMPLEX", "all":"' + optionText + '"}'
        )
      );
    } else {
      setDatas(
        makeSelectPara("inlo", { "inloClCd": "COMPLEX" })
      );
    }
  }, []);

  return (
    <>
      <FxSelectBase
        name={name ? name : "complexInloNo"}
        onChangeValue={onChangeValue}
        datas={datas}
        width={width ? width : "100%"}
        defaultValue={defaultValue}
        selectedData={props.selectedData}
      />
    </>
  );
};

/**
 *
 * @param {function} onChangeValue 선택된 값 전단 function(id, value)
 * @param {number} defaultValue 기본 선택값
 * @param {object} width
 * @param {number} complexInloNo
 * @param {string} optionText 전체선택 문구 추가
 * @param {string} name 변수명 없으면 "companyInloNo" 임
 * @returns
 */
export const FxSelectCompany = (props) => {
  const { onChangeValue, defaultValue, width, complexInloNo, optionText, name } = props;
  const [datas, setDatas] = React.useState({});

  useEffect(() => {
    if (optionText) {
      setDatas(
        makeSelectPara(
          null,
          null,
          '{"type":"inlo", "inloClCd":"COMPANY", "all":"' + optionText + '"}'
        )
      );
    } else {
      setDatas(makeSelectPara("inlo", { "inloClCd": "COMPANY" }));
    }
  }, []);

  useEffect(() => {
    if (datas && datas.para) {
      let newDatas = { ...datas };
      if (complexInloNo) {
        newDatas.para.complexInloNo = complexInloNo;
      } else {
        delete newDatas.para.complexInloNo;
      }
      setDatas(newDatas);

      console.log("FxSelectCompany : complexInloNo ", complexInloNo, newDatas);
    }
  }, [complexInloNo]);

  return (
    <>
      <FxSelectBase
        className="FxSelect"
        name={name ? name : "companyInloNo"}
        onChangeValue={onChangeValue}
        datas={datas}
        width={width}
        defaultValue={defaultValue}
        selectedData={props.selectedData}
      />
    </>
  );
};

/**
 * 공장 SELECT 박스
 * @param {function} onChangeValue 선택된 값 전단 function(id, value)
 * @param {number} defaultValue 기본 선택값
 * @param {object} width
 * @param {number} companyInloNo
 * @param {string} optionText 전체선택 문구 추가
 * @param {string} name 변수명 없으면 "plantInloNo" 임
 * @returns
 */
export const FxSelectPlant = (props) => {
  const { onChangeValue, defaultValue, width, companyInloNo, complexInloNo, optionText, name } = props;
  const [datas, setDatas] = React.useState({});

  useEffect(() => {
    if (optionText) {
      setDatas(
        makeSelectPara(
          null,
          null,
          '{"type":"inlo", "inloClCd":"PLANT", "all":"' + optionText + '"}'
        )
      );
    } else {
      setDatas(makeSelectPara("inlo", { "inloClCd": "PLANT" }));
    }
  }, []);

  useEffect(() => {
    if (datas && datas.para) {
      let newDatas = { ...datas };
      if (complexInloNo) {
        newDatas.para.complexInloNo = complexInloNo;
      } else {
        delete newDatas.para.complexInloNo;
      }

      setDatas(newDatas);
    }
  }, [complexInloNo]);

  useEffect(() => {
    if (datas && datas.para) {
      let newDatas = { ...datas };
      if (companyInloNo) {
        newDatas.para.companyInloNo = companyInloNo;
      } else {
        delete newDatas.para.companyInloNo;
      }

      setDatas(newDatas);
    }
  }, [companyInloNo]);

  return (
    <>
      <FxSelectBase
        className="FxSelect"
        name={name ? name : "plantInloNo"}
        onChangeValue={onChangeValue}
        datas={datas}
        width={width ? width : '100%'}
        defaultValue={defaultValue}
        selectedData={props.selectedData}
      />
    </>
  );
};


/**
 * 에너지 박스
 * @param {function} onChangeValue
 * @param {string} defaultValue
 * @param {object} width
 * @param {string} optionText 전체인 경우 문구
 * @returns
 */
export const FxSelectEnergy = (props) => {
  const { onChangeValue, defaultValue, width, optionText } = props;
  const [datas, setDatas] = React.useState({});

  useEffect(() => {
    if (optionText) {
      setDatas(makeSelectPara(null, null, '{"type":"energy", "all":"' + optionText + '"}'));
    } else {
      setDatas(makeSelectPara("energy", {},));
    }
  }, []);

  return (
    <>
      <FxSelectBase
        name="engId"
        onChangeValue={onChangeValue}
        datas={datas}
        width={width ? width : '100%'}
        defaultValue={defaultValue}
        selectedData={props.selectedData}
      />
    </>
  );
};


/**
 * 설비 선택 박스
 * @param onChangeValue 선택된 값 전단 function(id, value)
 * @param defaultValue 기본 선택값
 * @param complexInloNo 산단관리번호
 * @param width 넓이
 * @param {string} name 변수명 없으면 "facNo" 임
 * @returns
 */
export const FxSelectFacility = (props) => {
  const { onChangeValue, defaultValue, width, plantInloNo, name, optionText } = props;
  const [datas, setDatas] = React.useState({});


  useEffect(() => {
    if (optionText) {
      setDatas(makeSelectPara(null, null, '{"type":"inloFacility", "all":"' + optionText + '"}'));
    } else {
      setDatas(makeSelectPara("inloFacility", {},));
    }
  }, []);

  useEffect(() => {
    if (datas && datas.para) {
      let newDatas = { ...datas };
      if (plantInloNo) {
        newDatas.para.plantInloNo = plantInloNo;
      } else {
        delete newDatas.para.plantInloNo;
      }

      setDatas(newDatas);
    }
  }, [plantInloNo]);

  return (
    <>
      <FxSelectBase
        name={name ? name : "facNo"}
        onChangeValue={onChangeValue}
        datas={datas}
        width={width ? width : "100%"}
        defaultValue={defaultValue}
        selectedData={props.selectedData}
      />
    </>
  );
};



/**
 * 배관 선택 박스
 * @param onChangeValue 선택된 값 전단 function(id, value)
 * @param defaultValue 기본 선택값
 * @param complexInloNo 산단관리번호
 * @param width 넓이
  * @param {string} name 변수명 없으면 "pipeId" 임
*
 *  * @returns
 */
export const FxSelectPipe = (props) => {
  const { onChangeValue, defaultValue, width, complexInloNo, name, optionText } = props;
  const [datas, setDatas] = React.useState({});

  useEffect(() => {
    if (optionText) {
      setDatas(makeSelectPara(null, null, '{"type":"inloPipe", "all":"' + optionText + '"}'));
    } else {
      setDatas(makeSelectPara("inloPipe", {},));
    }
  }, []);

  useEffect(() => {
    if (datas && datas.para) {
      let newDatas = { ...datas };
      if (complexInloNo) {
        newDatas.para.complexInloNo = complexInloNo;
      } else {
        delete newDatas.para.complexInloNo;
      }

      setDatas(newDatas);
    }
  }, [complexInloNo]);

  return (
    <>
      <FxSelectBase
        name={name ? name : "pipeId"}
        onChangeValue={onChangeValue}
        datas={datas}
        width={width}
        defaultValue={defaultValue}
        selectedData={props.selectedData}
      />
    </>
  );
};


/**
 * 공정유형 박스
 * @param {function} onChangeValue
 * @param {string} defaultValue
 * @param {object} width
 * @param {string} optionText 전체인 경우 문구
 * @returns
 */
export const FxSelectProcTypeCd = (props) => {
  const { onChangeValue, defaultValue, width, optionText } = props;
  const [datas, setDatas] = React.useState({});

  useEffect(() => {
    if (optionText) {
      setDatas(makeSelectPara(null, null, '{"type":"code", "cdClass":"PROC_TYPE_CD", "all":"' + optionText + '"}'));
    } else {
      setDatas(makeSelectPara("code", { "cdClass":"PROC_TYPE_CD" },));
    }
  }, []);

  return (
    <>
      <FxSelectBase
        name="procTypeCd"
        onChangeValue={onChangeValue}
        datas={datas}
        width={width ? width : '100%'}
        defaultValue={defaultValue}
        selectedData={props.selectedData}
      />
    </>
  );
};



/**
 * 시간선택 박스
 * @param {function} onChangeValue
 * @param {string} defaultValue
 * @param {object} width
 * @param {string} optionText 전체인 경우 문구
 * @returns
 */
export const FxSelectTimeHourCd = (props) => {
  const { onChangeValue, defaultValue, width, optionText, name, selectedData } = props;
  const [datas, setDatas] = React.useState({});

useEffect(() => {
    if (optionText) {
      setDatas(makeSelectPara(null, null, '{"type":"code", "cdClass":"PS_TIME_HOUR_CL_CD", "all":"' + optionText + '"}'));
    } else {
      setDatas(makeSelectPara("code", { "cdClass":"PS_TIME_HOUR_CL_CD" },));
    }
  }, []);

  return (
    <>
      <FxMultiSelectBase
        name={name}
        onChangeValue={onChangeValue}
        datas={datas}
        defaultValue={defaultValue}
        selectedData={selectedData}
      />
    </>
  );
};


/**
 * 마이페이지 1:1문의 메뉴분류
 * @param {function} onChangeValue
 * @param {string} defaultValue
 * @param {object} width
 * @param {string} optionText 전체인 경우 문구
 * @returns
 */
export const FxSelectQnaMenuClCd = (props) => {
  const { onChangeValue, defaultValue, width, optionText } = props;
  const [datas, setDatas] = React.useState({});
 
  useEffect(() => {
    if (optionText) {
      setDatas(makeSelectPara(null, null, ' {"type":"code", "cdClass":"VUP_QNA_MENU_CL_CD", "all":"' + optionText + '"}'));
    } else {
      setDatas(makeSelectPara("code", {"cdClass":"VUP_QNA_MENU_CL_CD" },));
    }
  }, []);

  return (
    <>
      <FxSelectBase
        name="qnaMenuClCd"
        onChangeValue={onChangeValue}
        datas={datas}
        width={width ? width : '100%'}
        defaultValue={defaultValue}
        selectedData={props.selectedData}
      />
    </>
  );
};
